<template>
  <v-dialog v-model="localVisible" max-width="640" scrollable>
    <v-card>
      <v-card-title class="dialog-header white--text font-weight-bold">
        {{ idStatutEntreprise == 2 ? 'Fusionner avec un client' : 'Fusionner avec un prospect' }}
      </v-card-title>
      <v-card-text class="pt-4">
        <p class="body-2 grey--text text--darken-1 mb-4">
          Sélectionnez
          {{ idStatutEntreprise == 2 ? 'le client existant' : 'le prospect existant' }}
          avec lequel fusionner. La fiche actuelle sera conservée ; l'autre sera supprimée après transfert de ses données.
        </p>
        <div class="search-row mb-3">
          <v-text-field
            v-model="query"
            :placeholder="idStatutEntreprise == 2 ? 'Rechercher un client…' : 'Rechercher un prospect…'"
            outlined
            dense
            hide-details
            @keyup.enter="doSearch"
          />
          <v-btn depressed color="#0b87ba" dark class="search-btn" @click="doSearch">
            Rechercher
          </v-btn>
        </div>

        <div v-if="loading" class="text-center py-6">
          <v-progress-circular indeterminate color="#0b87ba" />
        </div>

        <template v-else-if="results.length > 0">
          <v-list dense class="result-list">
            <v-list-item
              v-for="e in results"
              :key="e.id_entreprise"
              class="result-item"
              :class="{ 'result-item--disabled': !e.actif }"
              @click="handleSelect(e)"
            >
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">
                  {{ e.raison_sociale }}
                  <v-chip
                    v-if="!e.actif"
                    x-small
                    color="grey lighten-1"
                    text-color="grey darken-2"
                    class="ml-2 disabled-chip"
                  >Désactivé</v-chip>
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ [e.ville, e.code_postal].filter(Boolean).join(' — ') }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn small depressed color="#0b87ba" dark class="select-btn">
                  Sélectionner
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-pagination
            v-if="totalPages > 1"
            v-model="page"
            :length="totalPages"
            circle
            class="mt-3"
          />
        </template>

        <div v-else-if="searched" class="text-center py-8 grey--text">
          <v-icon large color="grey lighten-1">fa-search-minus</v-icon>
          <p class="mt-2">Aucun résultat</p>
        </div>

        <div v-else class="text-center py-8 grey--text">
          <p>Saisissez un nom pour rechercher</p>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close">Annuler</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/api/entreprise';

export default {
  name: 'FusionSearchDialog',
  props: {
    value: { type: Boolean, default: false },
    idStatutEntreprise: { type: [Number, String], default: null },
  },
  data() {
    return {
      query: '',
      results: [],
      loading: false,
      searched: false,
      page: 1,
      totalPages: 1,
    };
  },
  computed: {
    localVisible: {
      get() { return this.value; },
      set(v) { this.$emit('input', v); },
    },
  },
  watch: {
    value(v) {
      if (v) {
        this.doSearch();
      } else {
        this.reset();
      }
    },
    page() {
      this.doSearch();
    },
  },
  methods: {
    reset() {
      this.query = '';
      this.results = [];
      this.searched = false;
      this.page = 1;
      this.totalPages = 1;
    },
    close() {
      this.$emit('input', false);
    },
    doSearch() {
      this.loading = true;
      const searchingClients = this.idStatutEntreprise === 2;
      api.getEntreprises(
        20,
        this.query || '',
        searchingClients,
        !searchingClients,
        true, true, true, true,
        this.page - 1,
      ).then(res => {
        this.results = res.data.entreprise.rows;
        this.totalPages = res.data.entreprise.totalPages || 1;
        this.searched = true;
      }).catch(() => {
        this.$store.dispatch('notify', { message: 'Erreur lors de la recherche' });
      }).finally(() => {
        this.loading = false;
      });
    },
    handleSelect(entreprise) {
      this.$emit('select', entreprise);
      this.close();
    },
  },
};
</script>

<style scoped>
.search-row {
  display: flex;
  gap: 8px;
  align-items: flex-start;
}
.search-btn {
  letter-spacing: 0;
  text-transform: none;
  height: 40px;
  white-space: nowrap;
}
.dialog-header {
  background-color: #0b87ba;
}
.result-list {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
.result-item {
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
}
.result-item:last-child {
  border-bottom: none;
}
.result-item:hover {
  background-color: #f5f9fb;
}
.result-item--disabled {
  background-color: #fafafa;
  opacity: 0.75;
}
.result-item--disabled:hover {
  background-color: #f0f0f0;
}
.disabled-chip {
  font-size: 0.65rem;
  height: 16px;
  vertical-align: middle;
}
.select-btn {
  border-radius: 20px;
  font-size: 0.75rem;
  letter-spacing: 0;
  text-transform: none;
}
</style>
